export const EPF_REPORT_INITIAL_STATE = {
    report_month: ""
}